import React, { useState, Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import TextField from '@mui/material/TextField';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import apiService from '../../services/apiServices';
import dateFormats from '../../services/dateFormats';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { useParams } from 'react-router-dom';

export default function EditSalary() {
  const { t } = useTranslation();
  //const classes = useStyles();
  const toastInitial = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(toastInitial);
  const [workers, setWorkers] = useState([]);
  const [months, setMonths] = useState([]);
  const [total, setTotal]=useState();
  const {
    register,
    handleSubmit,
    setValue,
     watch,
    control,
    formState: { errors },
  } = useForm();
  let { id } = useParams();
  useEffect(() => {
    apiService()
      .query('getWorkerSalaries', 'id=' + id)
      .then((response) => {
        if (response.success) {
          response.data[0].SalaryDate = dateFormats(
            response.data[0].SalaryDate
          );
          const fields = Object.keys(response.data[0]);
          fields.map((field) =>
            setValue(field, response.data[0][field].toString())
          );
          apiService()
            .get('selectworker')
            .then((w) => {
              if (w.success) {
                setWorkers(w.data);
                setValue(
                  'WorkerId',
                  w.data.find(function (e) {
                    return e.id === response.data[0].WorkerId;
                  })
                );
              } else {
                window.alert('Error:' + response.errorMessage);
              }
            });
          apiService()
            .get('months')
            .then((mon) => {
              if (mon.success) {
                setMonths(mon.data);
                setValue(
                  'Month',
                  mon.data.find(function (e) {
                    return e.id === response.data[0].Month;
                  })
                );
              } else {
                window.alert('Error:' + response.errorMessage);
              }
            });
        } else {
          //alert('Error:' + response.errorMessage);
        }
      });
  }, [id, setValue, watch]);

  const onSubmit = (data) => {
    // WorkerId/Month may be either the selected {id,...} object or a raw id
    // (depending on load timing) — guard so Save never throws on undefined.
    data.WorkerId = data.WorkerId?.id ?? data.WorkerId;
    data.Month = data.Month?.id ?? data.Month;
    apiService()
      .put('salaries', data)
      .then((response) => {
        if (response.success) {
          setToast({
            open: true,
            message: t('common.savedSuccess'),
            variant: 'success',
          });
        } else {
          setToast({
            open: true,
            message: t('common.errorOccurred'),
            variant: 'error',
          });
        }
      });
  };
  
  function changeHandler(event){
    //console.log(watch("Advances"));
    setTotal(watch("Salary")-watch("Advances"))

  }
  console.log(total);
  return (
    <div className="">
      <Fragment>
        <Toast {...toast} />
        <TopActions
          newHref="/dashboard/addworker"
          save={handleSubmit(onSubmit)}
        />

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Personal Data
            </Typography>
            <form>
              <Grid container spacing={3}>
                <TextField
                  sx={{ display: 'none' }}
                  variant="outlined"
                  id="id"
                  name="Id"
                  {...register('Id')}
                  value={id}
                />
                <Grid item xs={12} sm={3} lg={5}>
                  <SelectController
                  placeholder={t('salaries.workerPlaceholder')}
                    error={errors.WorkerId}
                    control={control}
                    options={workers}
                    name="WorkerId"
                    register={{ ...register('WorkerId') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                  placeholder={t('common.month')}
                    error={errors.Month}
                    control={control}
                    options={months}
                    name="Month"
                    register={{ ...register('Month') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                  placeholder={t('common.date')}
                    error={errors.SalaryDate}
                    control={control}
                    type="date"
                    register={{ ...register('SalaryDate') }}
                  />
                </Grid>

                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                  placeholder={t('salaries.salary')}
                    error={errors.Salary}
                    control={control}
                    symbol="€"
                    register={{ ...register('Salary') }}
                    changeHandler={changeHandler}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                  placeholder={t('salaries.advance')}
                    error={errors.Advances}
                    control={control}
                    symbol="€"
                    register={{ ...register('Advances') }}
                    changeHandler={changeHandler}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                  placeholder={t('salaries.total')}
                    error={errors.Totali}
                    control={control}
                    symbol="€"
                    value={total}
                  />
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Fragment>
    </div>
  );
}
